var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.0001,
    height: 15.9955,
    viewBox: "0 0 16.0001 15.9955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0.000117478V7.99779C8 12.4147 4.41827 15.9955 0 15.9955V7.99779C0 3.58083 3.58173 0.000117478 8 0.000117478Z",
    fill: "#D6A102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0001 15.9953V7.99767C16.0001 3.58072 12.4183 0 8.00006 0V7.99767C8.00006 12.4146 11.5818 15.9953 16.0001 15.9953Z",
    fill: "#508FCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif14);
export default __webpack_public_path__ + "static/media/motif-14.59687bdc8fd93027e5de0129fa190cb5.svg";
export { ForwardRef as ReactComponent };